// extracted by mini-css-extract-plugin
module.exports = {"modal":"AccountDeletionNew_modal__2_KIZ","describe":"AccountDeletionNew_describe__LTzVY","hint":"AccountDeletionNew_hint__3kADr"};